import { APIHandler } from "utilities/apiHandler";

import { OutboundPaymentsEntity } from "./OutboundPaymentsExternal.api.types";

export interface IOutboundPaymentsExternalHandler {
    get(shareToken: string): Promise<OutboundPaymentsEntity>;
}

export class OutboundPaymentsExternalHandler implements IOutboundPaymentsExternalHandler {
    async get(shareToken: string, fromEmail?: boolean): Promise<OutboundPaymentsEntity> {
        return await APIHandler(`/api/OnlinePayments/OutboundPaymentExternal`, {
            method: "GET",
            data: {
                shareToken,
                fromEmail,
            },
            responseType: OutboundPaymentsEntity,
        });
    }
}
